module.exports = __webpack_public_path__ + "img/flower.34c26022.png";